<template>
  <div class="Multiselect">
    <div v-for="(v, index) in internalValue" :key="index" class="Multiselect__item">
      <div class="Multiselect__action" @click="remove(v)">
        <IconBase iconName="remove"><IconRemove /></IconBase>
      </div>
      <span class="Multiselect__option">{{ v }}</span>
    </div>
    <div v-if="isOpen">
      <input class="Multiselect__input" type="text" v-model="search" />
      <div class="Multiselect__items">
        <div v-for="(option, index) in filteredOptions" :key="index" class="Multiselect__item">
          <div class="Multiselect__action" @click="add(option)">
            <IconBase height="18" width="18" iconName="add"><IconAdd /></IconBase>
          </div>
          <span class="Multiselect__option">{{ option }}</span>
        </div>
      </div>
    </div>
    <div v-else @click="isOpen=true" class="Multiselect__item">
      <div class="Multiselect__action">
        <IconBase height="18" width="18" iconName="add"><IconAdd /></IconBase>
      </div>
      <span class="Multiselect__placeholder">{{ placeholder }}</span>
    </div>
  </div>
</template>

<script>

import IconAdd from "./icons/IconAdd";
import IconRemove from "./icons/IconRemove";

export default {
  props: {
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: "Ajouter"
    }
  },
  data() {
    return {
      search: "",
      isOpen: false,
      internalValue: []
    };
  },
  computed: {
    filteredOptions() {
      return this.options.filter(option => !this.internalValue.includes(option) && option.includes(this.search));
    }
  },
  watch: {
    internalValue(newValue, oldValue) {
      this.$emit("input", newValue);
    }
  },
  methods: {
    add(item) {
      this.internalValue.push(item);
      this.isOpen = false;
    },
    remove(item) {
      this.internalValue = this.internalValue.filter(value => value !== item);
      this.isOpen = false;
    }
  },
  mounted() {
    if (Array.isArray(this.value)) {
      this.internalValue = [...this.value];
    }
  },
  components: {
    IconAdd,
    IconRemove
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/_variables.scss';

.Multiselect {
  &__items {
    max-height: 155px;
    overflow: auto;
    padding-left: $global-margin;
  }

  &__item {
    display: flex;
    align-items: center;
    margin-bottom: $global-margin;
    font-size: 0.85rem;
  }

  &__input {
    margin-bottom: $global-margin;
    padding: 0.75em;
    font-size: 1rem;
    font-weight: 500;
    width: 100%;
    background-color: $color-smoke;
    border-radius: $global-radius;
    border: 0;
  }

  &__action {
    opacity: 0.5;
    margin-right: $global-margin / 2;
    cursor: pointer;
  }

  &__placeholder {
    font-style: italic;
    color: $color-smoke;
    font-size: 0.85rem;
    cursor: pointer;
  }
}
</style>
